import { render, staticRenderFns } from "./imgComponent.vue?vue&type=template&id=4a47e5b4&scoped=true&"
import script from "./imgComponent.vue?vue&type=script&lang=js&"
export * from "./imgComponent.vue?vue&type=script&lang=js&"
import style0 from "./imgComponent.vue?vue&type=style&index=0&id=4a47e5b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a47e5b4",
  null
  
)

export default component.exports